import { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';

function getStepLabels(insuranceName, hasSubProducts) {
  const steps = {
    HOGAR: [
      'Tipo de construccion',
      'Planes',
      'Domicilio',
      'Resumen',
      'Medio de pago',
    ],
    'PERTENENCIAS PROTEGIDAS': [
      'Tipo de pertenencias',
      'Planes',
      'Beneficiario/s',
      'Resumen',
      'Medio de pago',
    ],
    'VIDA INDIVIDUAL': [
      'Productos',
      'Planes',
      'Beneficiario/s',
      'Resumen',
      'Medio de pago',
    ],
    TECNO: [
      'Productos',
      'Planes',
      'Marca y Modelo',
      'Resumen',
      'Medio de pago',
    ],
    'MOVILIDAD': [
      'Productos',
      'Planes',
      'Beneficiario/s',
      'Resumen',
      'Medio de pago',
    ],
    'ACCIDENTES PERSONALES': [
      'Productos',
      'Planes',
      'Beneficiario/s',
      'Resumen',
      'Medio de pago',
    ],
    'ROBO EN CAJERO AUTOMATICO': [
      'Productos',
      'Planes',
      'Beneficiario/s',
      'Resumen',
      'Medio de pago',
    ],
    MASCOTA: [
      'Productos',
      'Planes',
      'Mascota',
      'Domicilio',
      'Resumen',
      'Medio de pago',
    ],
    'INTEGRAL DE COMERCIO': [
      'Productos',
      'Actividad',
      'Planes',
      'Domicilio',
      'Resumen',
      'Medios de Pago',
    ],
    AUTOMOTOR: [
      'Productos',
      'Cotización',
      'Planes',
      'Datos',
      'Domicilio',
      'Resumen',
      'Medios de Pago',
    ],
  };

  if (hasSubProducts) return steps[insuranceName];
  return steps[insuranceName].slice(1, steps[insuranceName].length);
}

function getStep(hasSubProducts, requiredStep) {
  if (!hasSubProducts) return requiredStep - 1;

  return requiredStep;
}

export default function useWizardSteps(requiredStep) {
  const [stepLabels, setStepLabels] = useState([]);
  const [step, setStep] = useState();
  const { insuranceSelected } = useSelector(({ insurances }) => ({
    insuranceSelected: insurances.selected,
  }));

  const { insuranceCompany, insuranceName } = insuranceSelected || {};

  const hasSubProducts = useCallback(
    () => insuranceCompany.products.length > 1,
    [insuranceCompany]
  );

  useEffect(() => {
    setStepLabels(getStepLabels(insuranceName, hasSubProducts()));
  }, [hasSubProducts, insuranceName]);

  useEffect(() => {
    setStep(getStep(hasSubProducts(), requiredStep));
  }, [hasSubProducts, requiredStep]);

  return [step, stepLabels];
}
